import React from 'react';
import { deformatPercentage } from '../../utils/fmtUtils'
import { themes } from '../../styles/themes';
import { addDot } from '../../utils';
import constantes from '../../resources/constantes'
import styled from 'styled-components/macro';
import { responsive } from '../../resources/constantes.json';

const BarrasConsolidado = ({ tipo, data }) => {

    const actPvot = data?.pvot?.act
    const antPvot = data?.pvot?.ant
    const antAntPvot = data?.pvot?.antant

    const actVot = data?.vot?.act
    const antVot = data?.vot?.ant
    const antAntVot = data?.vot?.antant

    return (
        <>
            {actPvot && antPvot && antAntPvot &&
                <BarrasConsolidadoContainer>
                    <BarrasConsolidadoBarsContainer>
                        <BarrasConsolidadoBarsRow>
                            <BarrasConsolidadoLabel color={'#164192'} background={themes.actColor}>{actPvot}</BarrasConsolidadoLabel>
                            <BarrasConsolidadoBarContainer background={themes.actColorSecondary}>
                                <BarrasConsolidadoBar width={deformatPercentage(actPvot)} background={themes.actColor} />
                            </BarrasConsolidadoBarContainer>
                        </BarrasConsolidadoBarsRow>
                        <BarrasConsolidadoBarsRow>
                            <BarrasConsolidadoLabel color={'#FFF'} background={themes.antColor}>{antPvot}</BarrasConsolidadoLabel>
                            <BarrasConsolidadoBarContainer background={themes.antColorSecondary}>
                                <BarrasConsolidadoBar width={deformatPercentage(antPvot)} background={themes.antColor} />
                            </BarrasConsolidadoBarContainer>
                        </BarrasConsolidadoBarsRow>
                        <BarrasConsolidadoBarsRow>
                            <BarrasConsolidadoLabel color={'#FFF'} background={themes.antAntColor}>{antAntPvot}</BarrasConsolidadoLabel>
                            <BarrasConsolidadoBarContainer background={themes.antAntColorSecondary}>
                                <BarrasConsolidadoBar width={deformatPercentage(antAntPvot)} background={themes.antAntColor} />
                            </BarrasConsolidadoBarContainer>
                        </BarrasConsolidadoBarsRow>
                    </BarrasConsolidadoBarsContainer>
                    <Leyendas>
                        <Leyenda bold={true}>
                            <LeyendaYear>
                                {constantes.años.añoAct}
                            </LeyendaYear>
                            <LeyendaBar background={themes.actColor} />
                            <LeyendaValue>{addDot(actVot)}</LeyendaValue>
                        </Leyenda>
                        <Leyenda>
                            <LeyendaYear>
                                {constantes.años.añoAnt}
                            </LeyendaYear>
                            <LeyendaBar background={themes.antColor} />
                            <LeyendaValue>{addDot(antVot)}</LeyendaValue>
                        </Leyenda>
                        <Leyenda>
                            <LeyendaYear>
                                {constantes.años.añoAntAnt}
                            </LeyendaYear>
                            <LeyendaBar background={themes.antAntColor} />
                            <LeyendaValue>{addDot(antAntVot)}</LeyendaValue>
                        </Leyenda>
                    </Leyendas>
                </BarrasConsolidadoContainer>
            }</>
    );
}

export default BarrasConsolidado;

const BarrasConsolidadoContainer = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    width: 100%;
    gap:6rem;
    font-size: 2.4rem;

    @media (max-width: ${responsive.maxWidth.mobile}px) {
        font-size: 1.6rem;
    }
`

const BarrasConsolidadoBarsContainer = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    gap:4rem;
    width: 100%;
`


const BarrasConsolidadoBarsRow = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    height: 75px;
    width: 100%;
    gap: 0.5rem;
    @media (max-width: ${responsive.maxWidth.mobile}px) {
        height: 37px;
    }
`

const BarrasConsolidadoLabel = styled.div`
    width: 150px;
    height: 100%;
    flex-shrink: 0;
    border-radius: 100px 200px 0px 100px;
    display:flex;
    justify-content:center;
    align-items:center;
    color: ${({ color }) => color};
    font-weight: 700;
    text-transform: uppercase;
    background: ${({ background }) => background};
    @media (max-width: ${responsive.maxWidth.mobile}px) {
        width: 97px;
    }
`


const BarrasConsolidadoBarContainer = styled.div`
    height: 100%;
    border-radius: 0px 100px 100px 160px;
    flex-grow: 1;
    max-width: 686px;
    overflow: hidden;
    background: ${({ background }) => background};
`

const BarrasConsolidadoBar = styled.div`
    height: 100%;
    background: ${({ background }) => background};
    width: ${({ width }) => width};
    transition: width 0.8s;
`

const Leyendas = styled.div`
    text-align: center;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap:3rem;

    @media (max-width: ${449}px) {
        gap:1.4rem;
    }
`


const Leyenda = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap:0.5rem;
    font-weight: ${({ bold }) => bold ? 'bold' : 'unset'};

`

const LeyendaYear = styled.div``
const LeyendaBar = styled.div`
    height: 2.5rem;
    width:100%;
    border-radius: 100px;
    background: ${({ background }) => background};
    max-width:10rem;
    @media (max-width: ${responsive.maxWidth.mobile}px) {
        height: 1.4rem;
    }
`
const LeyendaValue = styled.div``